import { createLogger } from "@/sdk";
import { I18N } from "@uuip/unified-ui-platform-sdk";
const logger = createLogger("[Login i18n]");
export function loginI18nService() {
    const i18n = I18N.createService({ logger });
    return Object.assign(i18n, {
        get DEFAULT_INIT_OPTIONS() {
            return {
                debug: false,
                defaultNS: "login",
                ns: ["login"],
                fallbackLng: "en",
                backend: {
                    loadPath: "/login-i18n/{{lng}}/app.json"
                },
                detection: {
                    order: ["navigator", "cookie", "queryString", "localStorage", "sessionStorage", "htmlTag"],
                    lookupQuerystring: "lng",
                    lookupCookie: "lng",
                    lookupLocalStorage: "lng",
                    lookupSessionStorage: "lng"
                }
            };
        }
    });
}
const loginI18n = loginI18nService();
export const loginI18nInitPromise = loginI18n
    .init(loginI18n.DEFAULT_INIT_OPTIONS)
    .then(() => {
    logger.info("Login i18n initialized, language:", loginI18n.language);
})
    .catch((err) => {
    logger.error("Login i18n initialization failed", err);
});
export const loginI18nMixin = I18N.createMixin({ i18n: loginI18n });
export function t(key, options) {
    return loginI18n.t(key, options);
}
export { loginI18n };
